import { useRef, useState } from 'react';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import AdapterJalali from '@date-io/date-fns-jalali';

import { Block } from '@attom';

import CS from './Datepicker.module.scss';

export const Datepicker = ({
	// box control=
	boxClass = '',
	boxSpace = '',
	boxSize = '',
	//
	elSpace = 'py-8px px-20px',
	elClass = '',
	iconClass = '',
	// custom props:
	value = null,
	onChange = null,
	disablePast = null,
	// placeholder = '',
	label = '',
	required = null,

	...props
}) => {
	const pickerRef = useRef();
	const [initShow, setInitShow] = useState(true);

	const mask = '____/__/__';

	const changeHandler = (value) => {
		const returnValue = new Date(value);
		if (onChange && Date.parse(value)) onChange(returnValue);
		else if (onChange) onChange(value === null ? null : 'invalid');
	};

	return (
		<Block boxClass={boxClass} boxSize={boxSize} boxSpace={boxSpace}>
			<LocalizationProvider dateAdapter={AdapterJalali}>
				<DatePicker
					mask={mask}
					value={(value && new Date(value)) || null}
					inputFormat='yyyy/MM/dd'
					onChange={changeHandler}
					leftArrowButtonText='ماه قبلی'
					rightArrowButtonText='ماه بعدی'
					disablePast={disablePast}
					renderInput={({ inputRef, inputProps, InputProps }) => (
						<div className={`${CS.container}`}>
							<input
								ref={inputRef}
								{...inputProps}
								className={`${CS.input} ${elClass} ${elSpace} direction-ltr  ${value === 'invalid' ? 'tc-danger' : ''}`}
								placeholder=''
								onFocus={() => {
									if (initShow) pickerRef.current?.firstChild?.firstChild?.click();
									setInitShow(false);
								}}
								_isvalue={value ? 'true' : 'false'}
							/>
							{label && (
								<span className={CS.label} _islabel={value ? 'true' : 'false'}>
									{label}
								</span>
							)}
							{required && <span className={CS.required}>*</span>}
							<span className={`${CS.icon} ${iconClass}`} ref={pickerRef}>
								{InputProps?.endAdornment}
							</span>
						</div>
					)}
					{...props}
				/>
			</LocalizationProvider>
		</Block>
	);
};
